// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3gy5t","title":"ClientReferral_title__1uWFk","itemText":"ClientReferral_itemText__3FiQx"};